/**
 * Floating toolbar that appears when multiple nodes are selected
 * Provides actions like delete for selected nodes
 */

import { Panel } from "@xyflow/react"
import { useTranslation } from "react-i18next"

import { Trash2 } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

type SelectionToolbarProps = {
  selectedCount: number
  onDelete: () => void
}

export function SelectionToolbar({ selectedCount, onDelete }: SelectionToolbarProps) {
  const { t } = useTranslation()

  return (
    <Panel position="bottom-center">
      <div
        className={cn(
          "bg-background/95 flex items-center gap-2 rounded-xl border px-3 py-2 shadow-lg backdrop-blur-sm",
          "animate-in fade-in slide-in-from-bottom-2 duration-200"
        )}
      >
        <div className="flex items-center gap-2 border-r pr-3">
          <span className="text-foreground text-sm font-medium">
            {selectedCount} {t("mermaid.nodes_selected", "nodes selected")}
          </span>
        </div>

        <div className="flex items-center gap-1">
          <Button className="h-8 gap-2" size="sm" variant="destructive" onClick={onDelete}>
            <Trash2 className="size-4" />
            {t("mermaid.delete_selected", "Delete")}
          </Button>
        </div>
      </div>
    </Panel>
  )
}
